const _ = require('lodash');

function PostReviewDirective(CurrentUserService, ReviewService, SettingsService, CreateFormWizard, $state, $stateParams, $location, $window, $timeout, $, shopLocatorService, $uibModal) {
    return {
        restrict: 'E',
        template: require('./post-review.html'),
        scope: {
            product: '=',
            isAddingReview: '=?',
            department: '='
        },
        link(scope, element) {

            const POST_REVIEW_ENUM = {
                IDLE: 'IDLE',
                SAVING_REVIEW: 'LOADING',
                SAVED_REVIEW: 'LOADED'
            };

            const user = CurrentUserService.get();

            const buildViewModel = () => {
                return {
                    displayName: user.firstName,
                    age: user.age,
                    isStaffMember: user.isStaffMember || false,
                    location: '', // TODO: Pre-populate from the current selected store
                    vintage: '',
                    rating: -1,
                    recommendToFriend: 'yes',
                    title: '',
                    text: '',
                    reviewAsStaffMember: user.isStaffMember ? 'yes' : 'no',
                    createdOn: new Date(),
                    productId: scope.product.id,
                    storeNumber: ''
                };
            };

            scope.user = user;

            let modalInstance = null;

            scope.openTerms = () => {

                modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'post-review-terms-conditions',
                    scope,
                    size: 'lg',
                    windowClass: 'modal--post-review'
                });
            };

            scope.closeTerms = () => {
                modalInstance.dismiss('cancel');
            };

            const getSlides = () => {
                return element.find('.js-post-review-container .post-review-slide:not(.ng-hide)');
            };

            const getAllSlides = () => {
                return element.find('.js-post-review-container .post-review-slide');
            };

            let slider = scope.slider = CreateFormWizard.build(scope.reviewForm, scope, getSlides());
            scope.yesNoOptions = [{ value: 'yes', text: 'yes' }, { value: 'no', text: 'no' }];
            scope.review = buildViewModel();

            scope.state = POST_REVIEW_ENUM.IDLE;
            scope.ctrlName = _.uniqueId('post-review-');
            SettingsService.getSettingValue('BazaarVoice', 'BazaarvoiceApiCallEnabled').then(function (setting) {
                scope.bazaarvoiceApiCallEnabled = setting || false;
            });

            scope.post = () => {

                scope.state = POST_REVIEW_ENUM.SAVING_REVIEW;

                //Get the device fingerprint
                scope.review.fp = angular.element('#blackBox').val();
                if (!scope.bazaarvoiceApiCallEnabled) {
                    return ReviewService.add(scope.review).then(() => {
                        scope.state = POST_REVIEW_ENUM.SAVED_REVIEW;

                        $timeout(() => {
                            slider.moveNext();
                            const PAGE_HEADER_HEIGHT = 120;
                            const scrollElm = $('html').hasClass('touch') ? $('#scroll-body') : $('html, body');
                            scrollElm.animate({ scrollTop: $('.post-review').offset().top - PAGE_HEADER_HEIGHT }, 100); // set focus to the top for mobile
                        }, 100);
                    }, () => {
                        // TODO: Notify save failed
                        scope.state = POST_REVIEW_ENUM.IDLE; // Allow user to retry
                    });
                } else if (scope.bazaarvoiceApiCallEnabled) {
                    return ReviewService.addBVReview(scope.review).then(() => {
                        scope.state = POST_REVIEW_ENUM.SAVED_REVIEW;

                        $timeout(() => {
                            slider.moveNext();
                            const PAGE_HEADER_HEIGHT = 120;
                            const scrollElm = $('html').hasClass('touch') ? $('#scroll-body') : $('html, body');
                            scrollElm.animate({ scrollTop: $('.post-review').offset().top - PAGE_HEADER_HEIGHT }, 100); // set focus to the top for mobile
                        }, 100);
                    }, () => {
                        // TODO: Notify save failed
                        scope.state = POST_REVIEW_ENUM.IDLE; // Allow user to retry
                    });
                }
            };

            scope.hasVintage = () => {
                return scope.department
                    ? scope.department === 'Wine'
                    : !!scope.product.vintage;
            };

            scope.validDetails = (childForm) => {
                const isDetailsValid = !(childForm.displayName.$invalid || childForm.location.$invalid || childForm.age.$invalid);
                const storeValid = (scope.review.reviewAsStaffMember === 'yes') ? childForm.storeNumber.$valid : true;
                return (isDetailsValid && storeValid);
            };

            scope.validRating = () => {
                return (scope.review.rating > 0);
            };

            scope.validReview = (childForm) => {
                return !(childForm.title.$invalid || childForm.text.$invalid);
            };

            scope.backToReviews = () => {
                scope.isAddingReview = false;
            };

            function loadReviewViewModel() {
                scope.review = buildViewModel(); // clean model so customer can repost
                slider = scope.slider = CreateFormWizard.build(scope.reviewForm, scope, getSlides());
                scope.state = POST_REVIEW_ENUM.IDLE;
            }

            scope.$watch('isAddingReview', (isAdding) => {
                if (isAdding) { // reinitialize the screen so they can add additional reviews for the same product
                    loadReviewViewModel();
                }
            });

            //Load snare.js from mpsnare.iesnare.com.
            function loadSnareJs() {
                const el = document.createElement('script');
                el.src = 'https://mpsnare.iesnare.com/snare.js';
                document.body.appendChild(el);
            }

            function populateDeviceFingerprint() {
                let timeoutId;

                function useBlackboxString() {
                    if (typeof window.ioGetBlackbox !== 'function') { return; }

                    const bbData = window.ioGetBlackbox();
                    if (bbData.finished) {
                        clearTimeout(timeoutId);
                        document.getElementById('blackBox').value = bbData.blackbox;
                    }
                }
                timeoutId = setInterval(useBlackboxString, 500);
            }

            function _init() {
                loadSnareJs();
                populateDeviceFingerprint();
            }

            _init();

            scope.$on('login:success', function () {
                if (scope.isAddingReview) {
                    scope.review = buildViewModel(); // clean model so customer can repost
                    if (scope.review.isStaffMember) {
                        slider = scope.slider = CreateFormWizard.build(scope.reviewForm, scope, getAllSlides());
                    } else {
                        slider = scope.slider = CreateFormWizard.build(scope.reviewForm, scope, getSlides());
                    }

                    scope.state = POST_REVIEW_ENUM.IDLE;
                }
            });

            function setNotFoundError(value) {
                if (value) {
                    scope.userDetails.storeNumber.$error.notFound = value;
                } else {
                    delete scope.userDetails.storeNumber.$error.notFound;
                }
            }

            scope.getStoreLocation = function () {
                if (scope.review.storeNumber && scope.review.storeNumber.length > 3 && !isNaN(scope.review.storeNumber)) {
                    shopLocatorService.getStore(scope.review.storeNumber).then((store) => {
                        scope.review.location = 'BWS ' + store.Name;
                        scope.disableShopLocation = true;
                        setNotFoundError(false);
                    }, () => {
                        setNotFoundError(true);
                    });
                } else {
                    scope.disableShopLocation = false;
                    setNotFoundError(false);
                }
            };

        }

    };
}


module.exports = PostReviewDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/post-review/post-review-directive.js
 **/